export const SHOW_LOGIN_FORM_PAGE = 'events/SHOW_LOGIN_FORM_PAGE';

/**
 * @return {{type: string}}
 */
export const showLoginFormPage = (show) => ({
  type: SHOW_LOGIN_FORM_PAGE,
  payload: show,
});
